import React, {Fragment} from "react";
import {useContent} from "../../customHooks/useContent";
import content from "../../content/preparations.json";
import {PageHeader} from "../PageHeader";
import {generateRandomKey} from "../../utils/generateRandomKey";
import ReactHtmlParser from 'react-html-parser';

export const Preparations = () => {
    const {subtitle, bring, read, tips} = useContent(content);

    const generateListOfPublications = (list) => {
        return (
            <ul>
                {list.map(group => (
                    <li key={generateRandomKey()}>{group.category}
                        <ul>
                            {group.publications.map(publication => <li key={generateRandomKey()}>{ReactHtmlParser(publication)}</li>)}
                        </ul>
                    </li>
                ))}
            </ul>
        )
    };

    const generateTips = (list) => list.map(tip => (
        <Fragment key={generateRandomKey()}>
            <h3>{tip.title}</h3>
            <p>{ReactHtmlParser(tip.text)}</p>
        </Fragment>
    ));


    return (
        <Fragment>
            <PageHeader subtitle={subtitle} imageClass="header-school-preparations"/>
            <main>
                <div className="container">
                    <div className="row">
                        <section className="col-12">
                            <h2>{bring?.header}</h2>
                            <p>{bring?.paragraph}</p>
                        </section>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <section className="col-12">
                            <h2>{read?.header}</h2>
                            <p>{read?.paragraph}:</p>
                                {read?.list && generateListOfPublications(read.list)}
                        </section>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <section className="col-12">
                            <h2>{tips?.header}</h2>
                            {tips?.list && generateTips(tips.list)}
                        </section>
                    </div>
                </div>
            </main>
        </Fragment>
    )
};
